// Public API - Simple shared library with no configuration needed!
// Email workflow service - handles navigation to email builder
export * from './lib/email-workflow.service';

// Row action functions - pass namespace as parameter like other integrations
export * from './lib/email-row-actions';

// Send email component - standalone component for composing emails
export * from './lib/send-email/send-email.component';
